import React from 'react'
import PropTypes from 'prop-types'
import {
  DIYUpdatePayments,
  ScrolledIntoView,
  EVENTS_LABELS
} from 'src/constants/trackingEvents'
import { FormattedMessage } from 'react-intl'
import { Waypoint } from 'react-waypoint'
import {
  Panel,
  Format,
  Lock,
  InlineTextLock,
  Select,
  Text
} from 'src/Components'
import {
  dispatchEvent,
  oneTimeTagEventDispatcher
} from 'src/helpers/tagManager'

import styles from './PrincipalPayments.module.scss'

const propTypes = {
  addPayment: PropTypes.number.isRequired,
  setAddPayment: PropTypes.func.isRequired,
  addPaymentSavingsYears: PropTypes.number.isRequired
}

const scrollIntoView = oneTimeTagEventDispatcher(ScrolledIntoView, {
  eventLabel: EVENTS_LABELS.PrincipalPaymentsSection
})

const PrincipalPayments = ({
  withCurrentHomeData,
  addPayment,
  setAddPayment,
  addPaymentSavings,
  principalOptions,
  addPaymentSavingsYears
}) => (
  <>
    <Panel.Heading className={styles.payMoreText}>
      <FormattedMessage
        id='Homeowner.interestCard.payMorePart1'
        defaultMessage='Tip: If you pay just {amount} more each month, you could save {total}'
        values={{
          amount: (
            <Select
              inline
              value={addPayment}
              options={principalOptions}
              optionValue={Format.currency}
              className={styles.select}
              disabled={!withCurrentHomeData}
              onChange={value => {
                dispatchEvent(DIYUpdatePayments)
                setAddPayment(parseFloat(value))
              }}
            />
          ),
          total: (
            <Lock enabled={!withCurrentHomeData}>
              <Text
                size='xl'
                weight='light'
                color='green'
                className={styles.paymentSavings}
              >
                <Format.Currency value={Math.round(addPaymentSavings)} />
              </Text>
            </Lock>
          )
        }}
      />
    </Panel.Heading>
    <Text className={styles.interestText} size='s' align='center'>
      <FormattedMessage
        id='Homeowner.interestCard.payMorePart2'
        defaultMessage="in interest over the rest of your loan. You'd also be done with the loan and no longer making payments {yearsEarlier}!"
        values={{
          yearsEarlier: (
            <Text element='span' color='green'>
              <FormattedMessage
                id='Homeowner.interestCard.payMorePart2.yearsEarlier'
                defaultMessage='{years} years earlier'
                values={{
                  years: (
                    <InlineTextLock enabled={!withCurrentHomeData}>
                      {addPaymentSavingsYears}
                    </InlineTextLock>
                  )
                }}
              />
            </Text>
          )
        }}
      />
    </Text>
    <Waypoint onEnter={scrollIntoView} bottomOffset='50%'>
      <div />
    </Waypoint>
  </>
)

PrincipalPayments.propTypes = propTypes

export default PrincipalPayments
